import React from "react";
import {useTranslation} from "react-i18next";
import styles from "./PostContainer.module.scss";

const PostContainer = (props: any) => {
  const { t } = useTranslation();
  const headerText = `${props.header}`;

  const handleBack = () => {
    props.onBack();
  };

  return (
    <div style={{ width: "100%", paddingBottom: "40px", position: 'relative' }}>
      {props.backable && (
        <div
          className={styles.postHeader}
          style={{ paddingTop: props.save ? 0 : 20 }}
        >
          {/* <div className={styles.cardPostHeader}>{t(headerText)}</div> */}
            <div className={styles.backButton} onClick={handleBack}>
              {t("Back")}
            </div>
        </div>
      )}
      <div className={styles.cardPost}>{props.children}</div>
    </div>
  );
};

export default PostContainer;
